<template>
  <v-container fluid class="marketproject-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Marketing Project</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Project</p>
                        <v-select
                          class="mb-4"
                          :items=marketprojecttype
                          v-model="marketproject.projecttype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the project type">
                        </v-select>
                        <v-menu
                          ref="menu_marketprojectdate"
                          v-model="menu_marketprojectdate"
                          :close-on-content-click="false"
                          :return-value.sync="marketproject.projectdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="marketproject.projectdate"
                              label="Project Date"
                              v-bind="attrs"
                              v-bind:value="marketproject.projectdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the project date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="marketproject.projectdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_marketprojectdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_marketprojectdate.save(marketproject.projectdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="mb-4"
                          v-model="marketproject.projectname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Project Name"
                          persistent-hint
                          single-line hint="Enter the project name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.filter(location=>location.locationstatus=='Active').map(x => {return {text: x.locationname, value: x._id};})"
                          v-model="marketproject.locationid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="users.filter(user=>user.userstatus=='Active').map(x => {return {text: x.username, value: x._id}})"
                          v-model="marketproject.repid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="In Charge"
                          persistent-hint
                          single-line hint="Please choose the person in charge">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="brands.filter(brand=>brand.brandstatus=='Active' && brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id}})"
                          v-model="marketproject.brandid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Brand"
                          persistent-hint
                          single-line hint="Please choose the brand">
                        </v-select>
                        <v-textarea
                          v-model="marketproject.marketprojectnote"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                     
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/marketproject/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertMarketProject()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,
      imageurl: undefined,
      menu_marketprojectdate: false,
      step: 1,
      marketproject: {},
      marketprojecttype: ['Branding Project', 'Digital Project', 'Other Project'],
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Location', ['locations']),
    ...mapState('MarketProject', ['isReceiving']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('MarketProject', ['getMarketProjects', 'insertMarketProjectRequest', 'insertMarketProjectWithImageRequest']),
    ...mapActions('User', ['getUsersRequest']),
    checkError(){
      if(!this.marketproject.projecttype){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.marketproject.projectdate){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.marketproject.projectname){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.marketproject.locationid){
        this.errortag = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertMarketProject() {
      if(this.marketproject.imagefile!=null) await this.insertMarketProjectWithImageRequest(this.marketproject);
      else await this.insertMarketProjectRequest(this.marketproject);
      router.push('/marketproject/list');
    },
    onFileChange(file) {
      if (!file) {return;}
      this.marketproject.imagefile = file;
      this.marketproject.imagename = file.name;
      this.createImage(file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
  },
  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
